import { apiGet, apiPatch } from './client';
import type {
  CalcMethodMap,
  CalcMethodMapBatchRequest,
  CalcMethodMapKey,
} from '../types/CalcMethodMap';

// Server returns rows without `idKey` — the page needs a single key for the grid.
// Synthesize `bal|ast` here so callers (LopCrudPage idField) work uniformly.
function withIdKey(rows: Omit<CalcMethodMap, 'idKey'>[]): CalcMethodMap[] {
  return rows.map((r) => ({ ...r, idKey: `${r.balanceTypeId}|${r.assetTypeId}` }));
}

function stripIdKey(rows: CalcMethodMap[]): Omit<CalcMethodMap, 'idKey'>[] {
  return rows.map(({ idKey, ...rest }) => rest);
}

function parseIdKey(idKey: string): CalcMethodMapKey {
  const [b, a] = idKey.split('|');
  return { balanceTypeId: Number(b), assetTypeId: Number(a) };
}

export async function getCalcMethodMap(): Promise<CalcMethodMap[]> {
  const rows = await apiGet<Omit<CalcMethodMap, 'idKey'>[]>('/api/calc-method-map');
  return withIdKey(rows);
}

export async function saveCalcMethodMapBatch(
  added: CalcMethodMap[],
  modified: CalcMethodMap[],
  deletedIdKeys: string[],
): Promise<CalcMethodMap[]> {
  const body: CalcMethodMapBatchRequest = {
    added: stripIdKey(added),
    modified: stripIdKey(modified),
    deleted: deletedIdKeys.map(parseIdKey),
  };
  const fresh = await apiPatch<CalcMethodMapBatchRequest, Omit<CalcMethodMap, 'idKey'>[]>(
    '/api/calc-method-map/batch',
    body,
  );
  return withIdKey(fresh);
}
